/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/ui/dialogs/CommonSelectItemsDialog',
	'./SelectItemsNavigationDialog',
	'jquery',
	'underscore',
	'text!../templates/MultipleColumnNavigation.html',
	'../../../lib/@waca/dashboard-common/dist/ui/NextView',
	'../nls/StringResources',
	'doT'
], function(View, SelectItemsDialog, $, _, MultipleColumnNavigation, NextView, stringResources, dot){


	var MultipleColumnsNavigationDialog = View.extend({

		events: {
			'primaryaction .itemRow': '_selectItem',
			'keydown .itemRow':'_moveFocus'
		},

		_possibleItems:[],
		_eventHandler:null,
		_currentIndex: null,
		_currentElementSelected:null,
		_selectedDrillGroup:null,
		_nextView:null,
		_templateArray:[],

		init:function(options){
			MultipleColumnsNavigationDialog.inherited('init', this, arguments);
			this._possibleItems = options.possibleItems;
			this._templateArray = [];
			this._eventHandler = options.eventHandler;
		},

		render: function() {
			this._renderDataItems();
			this.dotTemplate = dot.template(MultipleColumnNavigation);
			var sHtml = this.dotTemplate({ array:this._templateArray });
			this.$el.html(sHtml);
			this._setFocus();
		},

		_renderDataItems: function() {
			var dataItemIds = _.keys(this._possibleItems);
			for (var i = 0; i < dataItemIds.length; i++) {
				this._templateArray.push({ columnId: dataItemIds[i], label: this._possibleItems[dataItemIds[i]][0].dataItem.getLabel() });
			}
		},

		_selectItem: function(evt) {
			this._currentElementSelected = $(evt.currentTarget);
			var currentSelectedItem = $(evt.currentTarget).attr('data');


			var selectedItemInfo = this._possibleItems[currentSelectedItem];
			var selectViewOptions = {
				possibleItems: selectedItemInfo,
				eventHandler: this._eventHandler,
				currentSelectedItem: currentSelectedItem
			};

			var selectItems = new SelectItemsDialog(selectViewOptions);
			selectItems = selectItems.render();

			var nextViewOptions = {
				previousView: this.$el.closest('.toolbarPopoverContent'),
				nextView: selectItems,
				title: stringResources.get('navigateTitle')
			};

			this._nextView = new NextView(nextViewOptions);
			this._nextView = this._nextView.render();

			var contianer = this.$el.closest('.popover-content');
			contianer.append(this._nextView.$el);
		},

		_setFocus:function(){
			this.$el.find('.itemRow').attr('tabindex','-1');
			this.$el.find('.itemRow:first').attr('tabindex','0');
		},

		handleSelection:function(selectedItem){

			var item = $('<div/>').addClass('itemRow').attr('data', selectedItem[0].id);
			$('<div/>').addClass('text').text(selectedItem[0].label).appendTo(item);
			$('<div class="rightArrow"><span class="wfg_rightarrow"></span></div>').appendTo(item);

			this._currentElementSelected.replaceWith(item);

			this._possibleItems[this._currentIndex].dataItemId = selectedItem[0].id;
			this._eventHandler.handleSelection(selectedItem);

		},


		changeDrillGroup: function(drillGroupId, dataItemId) {

			this._selectedDrillGroup = drillGroupId;
			this._eventHandler.changeDrillGroup(drillGroupId, dataItemId);

		},

		remove: function(){
			MultipleColumnsNavigationDialog.inherited('remove', this, arguments);
			if(this._nextView){
				this._nextView.remove();
			}
		}

	});

	return MultipleColumnsNavigationDialog;
});
